import React, { useEffect, Component } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
// Components
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { PodcastsPage } from './pages/PodcastsPage';
import { Season1Page } from './pages/Season1Page';
import { Season2Page } from './pages/Season2Page';
import { GuestsPage } from './pages/GuestsPage';
import { OutreachPage } from './pages/OutreachPage';
import { BookstorePage } from './pages/BookstorePage';
import { DonatePage } from './pages/DonatePage';
import { MillionMovementPage } from './pages/MillionMovementPage';
import { EndsAdventuresPage } from './pages/EndsAdventuresPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { SharePage } from './pages/SharePage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0" data-mp="5yi8qe3h5da">
      <Routes location={location} key={location.pathname} data-id="element-1" data-mp="4wvhonpuufq">
        <Route path="/" element={<HomePage data-id="element-3" data-mp="2zlld2w2kqak3" />} data-id="element-2" data-mp="2zl3alhpbj03q" />
        <Route path="/about" element={<AboutPage data-id="element-5" data-mp="2zn6aquk6q9m6" />} data-id="element-4" data-mp="2zmeowbge3q93" />
        <Route path="/podcasts" element={<PodcastsPage data-id="element-7" data-mp="33nq5xsl7735o" />} data-id="element-6" data-mp="33morde4z3yj7" />
        <Route path="/podcasts/season-1" element={<Season1Page data-id="element-9" data-mp="38m1gy6n8bjph" />} data-id="element-8" data-mp="33mym1f0yqtv8" />
        <Route path="/podcasts/season-2" element={<Season2Page data-id="element-11" data-mp="38nunzn1r85y0" />} data-id="element-10" data-mp="38kqcs5pvg9xu" />
        <Route path="/guests" element={<GuestsPage data-id="element-13" data-mp="3dlw6o6v9q38y" />} data-id="element-12" data-mp="3dkl3o99ncziw" />
        <Route path="/outreach" element={<OutreachPage data-id="element-15" data-mp="nvj4pj9gikrb" />} data-id="element-14" data-mp="3dmfn1j59sjkv" />
        <Route path="/bookstore" element={<BookstorePage data-id="element-17" data-mp="nv0xjrl9am4m" />} data-id="element-16" data-mp="nwc2huqftzxb" />
        <Route path="/donate" element={<DonatePage data-id="element-19" data-mp="su43rfcz2ye6" />} data-id="element-18" data-mp="nxwvvh10nctl" />
        <Route path="/million-movement" element={<MillionMovementPage data-id="element-21" data-mp="swgkjp6zv2pn" />} data-id="element-20" data-mp="stc864jdl0nw" />
        <Route path="/ends-adventures" element={<EndsAdventuresPage data-id="element-23" data-mp="34x4lozr5n72" />} data-id="element-22" data-mp="35ymodf6r9ya" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-25" data-mp="3ubrgkhvzwc2x" />} data-id="element-24" data-mp="3uct25gan0gyw" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-27" data-mp="d4e94339pv1g" />} data-id="element-26" data-mp="3ucje3y95kjvu" />
        <Route path="/share" element={<SharePage data-id="element-29" data-mp="d2l8p5j9071w" />} data-id="element-28" data-mp="d3cvbquvaug1" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <Router data-id="element-30" data-mp="83i23gnmdsrt">
      <div className="flex flex-col min-h-screen bg-dark-700 text-dark-50 font-sans selection:bg-gold-500 selection:text-dark-900" data-id="element-31" data-mp="3gle7udba4tcj">
        <ScrollToTop data-id="element-32" data-mp="3bn2zk70muqwf" />
        <Navbar data-id="element-33" data-mp="3bnmk7vho3te5" />
        <main className="flex-grow" data-id="element-34" data-mp="3bo4l55f9yvse">
          <AnimatedRoutes data-id="element-35" data-mp="3qaxttruah3bm" />
        </main>
        <Footer data-id="element-36" data-mp="3qbzd2jlgkw4f" />
      </div>
    </Router>;
}